import Accordion from 'react-bootstrap/Accordion';
import Form from 'react-bootstrap/Form';
import Results, { hasVisibleResults } from './Results';
import Table from 'react-bootstrap/Table';
import ValueDisabled from './ValueDisabled';

import { useTranslation } from 'react-i18next';
import { byCategoryOrdered } from './functions';

import './PlayerDecisionsTable.css';

const DecisionRow = ({ decision, status }) => {
    const { t } = useTranslation();
    const help = t(`decisions.${decision.name}.description`) + (decision.price ? `(${decision.price}€)` : '');
    const unit = decision.unit ? '(' + t(`unit.${decision.unit}`) + ')' : '';
    return <tr key={decision.name}>
        <td key="name" className="align-middle">
            <Form.Label className="mb-0" title={help}>{t(`decisions.${decision.name}.label`)} {unit}</Form.Label>
        </td>
        {
            decision.values.map((value, i) => <td key={i} className="align-middle text-center">
                <ValueDisabled type={decision.type} value={value} />
            </td>)
        }
    </tr>
};

const SubcategoryDecisions = ({ category, subcategory, decisions, round, status }) => {
    const { t } = useTranslation();
    let title = t(`categories.${category}.${subcategory}.title`);
    return <>
        <tr key={subcategory}>
            <td key="name" className="align-middle fw-bold" colSpan={round + 1}>
                <Form.Label className="mb-0">{title}</Form.Label>
            </td>
        </tr>
        {
            Object.values(decisions).map(decision => <DecisionRow key={decision.name} decision={decision} status={status} />)
        }
    </>
};

const CategoryDecisions = ({ category, subcategories, rounds, round, status, results, team }) => {
    const { t } = useTranslation();
    let title = t(`categories.${category}.title`);
    const hasDecisions = Object.keys(subcategories).length > 0;
    return <Accordion.Item eventKey={category}>
        <Accordion.Header>
            { title }
        </Accordion.Header>
        <Accordion.Body>
            {hasDecisions &&
                <div>
                    <div style={{ display: "inline-block" }}>
                        <Table striped>
                            <thead>
                                <tr>
                                    <th key="name" style={{ width: "20rem" }}>{t('game.decisions')}</th>
                                    {Array.from({ length: rounds }, (_, i) => {
                                        return <th key={i} className="decisions-table-header">{`${t('games.round')} ${i + 1}`}</th>;
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    Object.entries(subcategories).map(([subcategory, decisions]) => <SubcategoryDecisions
                                            key={subcategory}
                                            category={category}
                                            subcategory={subcategory}
                                            decisions={decisions}
                                            round={round}
                                            status={status}
                                        />)
                                }
                            </tbody>
                        </Table>
                    </div>
                </div>
            }
            <div>
                <Results results={results} team={team} category={category} rounds={rounds} />
            </div>
        </Accordion.Body>
    </Accordion.Item>;
};

const PlayerDecisionsTableDisabled = ({ team, decisionDefinitions, decisionValues, rounds, round, id, status, results }) => {
    const decisions = decisionValues?.decisions[team] || {};
    const defaultActiveKeys = [];
    const decisionsByCategory = byCategoryOrdered(decisions, decisionDefinitions);
    const visibleCategories = Object.entries(decisionsByCategory).filter(([category, subcategories]) =>
        Object.keys(subcategories).length > 0 || hasVisibleResults(results, team, category)
    );

    return (
        <div>
            <Accordion defaultActiveKey={defaultActiveKeys}>
                {
                    visibleCategories.map(([category, subcategories]) =>
                        <CategoryDecisions key={category} category={category} subcategories={subcategories} rounds={rounds} round={round} status={status} results={results} team={team} />)
                }
            </Accordion>
        </div>
    );
};

export default PlayerDecisionsTableDisabled;
